import { Button, ButtonProps, Link as ChakraLink, Flex, Tooltip } from "@chakra-ui/react";
import { CiCircleInfo, CiCircleList, CiHome, CiUser } from "react-icons/ci";
import { IconType } from "react-icons/lib";
import { Link as WouterLink, useLocation } from "wouter";

import { useStatusQuery } from "@/queries/query-status";

const SidebarButton = ({
  label,
  to,
  Icon,
  isExternal,
  ...rest
}: {
  label: string;
  to: string;
  Icon: IconType;
  isExternal?: boolean;
} & ButtonProps) => {
  const [location] = useLocation();

  return (
    <Tooltip label={label} placement="right" hasArrow>
      <Button
        {...rest}
        p={0}
        minW="button"
        variant={location === to ? "primary" : "secondary"}
        {...(isExternal
          ? { href: to, isExternal: true, as: ChakraLink }
          : { as: WouterLink as typeof ChakraLink, to })}
      >
        <Icon size={25} />
      </Button>
    </Tooltip>
  );
};

export const TbiSidebar = () => {
  const statusResponse = useStatusQuery();

  const isAdmin = statusResponse.data?.authenticated && statusResponse.data?.hasAdminAccess;
  const hasWriteAccess = statusResponse.data?.authenticated && statusResponse.data?.hasWriteAccess;

  if (!hasWriteAccess && !isAdmin) {
    return null;
  }

  return (
    <>
      <Flex pointerEvents="none" w="button" />

      <Flex
        sx={{
          "@media print": {
            display: "none",
          },
        }}
        position="fixed"
        top="50%"
        transform="translateY(-50%)"
        flexDir="column"
        justifyContent="center"
        gap={4}
        zIndex={1000}
        h="full"
      >
        {hasWriteAccess && <SidebarButton label="Nieuwe berekening" to={`/`} Icon={CiHome} />}
        <SidebarButton label="Rapportages" to={`/reports`} Icon={CiCircleList} />
        {isAdmin && <SidebarButton label="Gebruikers" to={`/users`} Icon={CiUser} />}
        {isAdmin && (
          <SidebarButton
            label="Documentatie"
            isExternal
            to="https://docs.klimaat-scan.nl/"
            Icon={CiCircleInfo}
            position="absolute"
            bottom={4}
          />
        )}
      </Flex>
    </>
  );
};
